import { Region } from 'angular-api-gateway/v1/model/region';

export const TESTING_STAND_DOMAIN: string = 'lenta.tech';
export const TESTING_STAND_PROD_REVIEW: string = 'pr-review';

export const LENTA_DOMAIN: string = 'lenta.com';

export const MAIN_FAKE_REGIONS: string[] = [
  'www',
  'lenta',
  'lenta-online',
  'online',
  'stage',
  'green',
  'omniweb',
  'domlenta',
  'beta',
];
export const QA_STANDS: string[] = ['lenta-angular', 'dom-angular', 'utkonos-angular'];

export enum SplitHostValue {
  'production' = 2,
  'test' = 4,
}

export enum CityIds {
  MOSCOW = 1,
}

export const DEFAULT_CITY_SLUG: string = 'moscow';
export const DEFAULT_CITY_SLUG_MONETKA: string = 'ekb';
export const DEFAULT_CITY_NAME: string = 'Москва и МО';
export const DEFAULT_CITY: Region = {
  id: 1,
  name: 'Москва',
  slug: DEFAULT_CITY_SLUG,
  centerLat: '55.75222000',
  centerLng: '37.61556000',
  isDefault: true,
  mainDomain: true,
};
